import {RECEIVE_PROMOCIONES} from '../actions/PromocionesActions';
import {combineReducers} from 'redux';
import normalizeDatos from "../normalizers/normalizePromociones";

function categoriasById(state = {
    isFetching: false,
    didInvalidate: true,
    categorias: []
}, action) {
    switch (action.type) {
        case RECEIVE_PROMOCIONES:
            return Object.assign({}, state, {
                isFetching: false,
                didInvalidate: false,
                categorias: action.promociones.entities.categorias,
                lastUpdated: action.receivedAt
            });
        default:
            return state
    }
}


function allCategorias(state = [], action) {
    switch (action.type) {
        case RECEIVE_PROMOCIONES:
            return Object.keys(action.promociones ? action.promociones.entities.categorias : []);
        default:
            return state
    }
}


const categorias = combineReducers({
    byId: categoriasById,
    allIds: allCategorias
});

export default categorias;


// WEBPACK FOOTER //
// ./src/reducers/categorias.js